
import React from "react";

function About() {
  return (
    <div className="about-page">
      <h1>About DramaQwizz</h1>
      <p>
        Welcome to My blog DramaQwizz ! This blog is dedicated to give you
        review about kdrama.
      </p>
      <p>
        I created this blog to document reviews about the latest as well as the
        old kdrams . Here, you will get to know whether you should watch
        particular kdrama or not
      </p>
      <p>
        Feel free to explore the blog and let me know if you have any questions
        or suggestions for future topics. COMING SOON !!
      </p>
    </div>
  );
}

export default About;


